import { ButtonV2, ButtonV2StyleProps, styled } from '@withjoy/joykit';
import { animationTransitionExt } from '@shared/utils/animationTransition';
import { pxToRem } from '@withjoy/joykit/theme';

export const StyledMenuButton = styled(ButtonV2)<{ isPreviewing: boolean }>`
  pointer-events: all;
  padding: 0px;
  width: ${pxToRem(42)};
  height: ${pxToRem(42)};
  min-width: unset;
`;

const menuButton = (isCustomPage?: boolean, topOffset?: number): ButtonV2StyleProps => {
  const topOffsetInRem = pxToRem(topOffset);
  return {
    position: 'fixed',
    zIndex: 'overlay',
    top: isCustomPage ? `calc(${pxToRem(14)} + ${topOffsetInRem})` : `calc(${pxToRem(20)} + ${topOffsetInRem})`,
    transition: animationTransitionExt({ property: 'top', duration: '250ms', timingFunction: 'ease-in-out' }),
    left: pxToRem(20),
    background: 'inherit !important',
    overflow: 'hidden',
    color: 'black',
  };
};

export const styles = {
  button: menuButton,
};
